var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgF3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_82_2654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 1.3335C4.32001 1.3335 1.33334 4.32016 1.33334 8.00016C1.33334 11.6802 4.32001 14.6668 8.00001 14.6668H11.3333V13.3335H8.00001C5.10668 13.3335 2.66668 10.8935 2.66668 8.00016C2.66668 5.10683 5.10668 2.66683 8.00001 2.66683C10.8933 2.66683 13.3333 5.10683 13.3333 8.00016V8.9535C13.3333 9.48016 12.86 10.0002 12.3333 10.0002C11.8067 10.0002 11.3333 9.48016 11.3333 8.9535V8.00016C11.3333 6.16016 9.84001 4.66683 8.00001 4.66683C6.16001 4.66683 4.66668 6.16016 4.66668 8.00016C4.66668 9.84016 6.16001 11.3335 8.00001 11.3335C8.92001 11.3335 9.76001 10.9602 10.36 10.3535C10.7933 10.9468 11.54 11.3335 12.3333 11.3335C13.6467 11.3335 14.6667 10.2668 14.6667 8.9535V8.00016C14.6667 4.32016 11.68 1.3335 8.00001 1.3335ZM8.00001 10.0002C6.89334 10.0002 6.00001 9.10683 6.00001 8.00016C6.00001 6.8935 6.89334 6.00016 8.00001 6.00016C9.10668 6.00016 10 6.8935 10 8.00016C10 9.10683 9.10668 10.0002 8.00001 10.0002Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_82_2654"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF3);
export default __webpack_public_path__ + "static/media/f3.1541728d919413b7549bb108eda70c1d.svg";
export { ForwardRef as ReactComponent };